module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-form column column-center"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "メールアドレス",
      "id": "username"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "パスワード",
      "id": "password",
      "show-password": ""
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-check-container"
  }, [_c('el-checkbox', {
    staticClass: "login-check",
    attrs: {
      "id": "login"
    },
    model: {
      value: (_vm.form.login),
      callback: function($$v) {
        _vm.$set(_vm.form, "login", $$v)
      },
      expression: "form.login"
    }
  }, [_vm._v("ログイン状態を維持")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#a3a3a3"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.shows = 1
      }
    }
  }, [_vm._v("パスワードをお忘れの方")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-box column column-center"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        return _vm.doLogin()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.ss()
      }
    }
  }, [_vm._v("ログイン")]), _vm._v(" "), _c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        _vm.shows = 4
      }
    }
  }, [_vm._v("新規登録")]), _vm._v(" "), _c('el-button', {
    staticClass: "facebook-btn",
    on: {
      "click": function($event) {
        return _vm.faceLogin()
      }
    }
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" Facebookでログイン\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "google-btn",
    on: {
      "click": function($event) {
        return _vm.googleLogin()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px",
      "border-radius": "50%",
      "vertical-align": "middle",
      "margin-right": ""
    },
    attrs: {
      "src": require("../../assets/images/google.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Googleでログイン")])])], 1), _vm._v(" "), (_vm.shows == 1) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("パスワードお忘れの方")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("メールアドレス")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "メールアドレスを入力"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendEmail()
      }
    }
  }, [_vm._v("認証コードを送信")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.shows == 2) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("パスワードお忘れの方")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("認証コード")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "認証コードを入力"
    },
    model: {
      value: (_vm.yzm),
      callback: function($$v) {
        _vm.yzm = $$v
      },
      expression: "yzm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendXin()
      }
    }
  }, [_vm._v("確認")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.shows == 3) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("パスワードお忘れの方")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("新しいパスワード")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "新しいパスワードを入力"
    },
    model: {
      value: (_vm.newPass),
      callback: function($$v) {
        _vm.newPass = $$v
      },
      expression: "newPass"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("新しいパスワードを確認")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "新しいパスワードを再入力"
    },
    model: {
      value: (_vm.aginPass),
      callback: function($$v) {
        _vm.aginPass = $$v
      },
      expression: "aginPass"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.edit()
      }
    }
  }, [_vm._v("登録")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.shows == 4) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("メールアドレス認証")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("メールアドレス")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "メールアドレスを入力"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendVEmail()
      }
    }
  }, [_vm._v("認証メールを送信")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.shows == 5) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("メールアドレス認証")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("認証コード")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "認証コードを入力"
    },
    model: {
      value: (_vm.vyzm),
      callback: function($$v) {
        _vm.vyzm = $$v
      },
      expression: "vyzm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendVXin()
      }
    }
  }, [_vm._v("確認")])], 1)], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo column row-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("ログイン")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("もっとワクワークする世の中を")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_vm._v("会員登録いただいた際のメールアドレスを入力し，「認証コードを送信」のボタンをクリックしてください。"), _c('br'), _vm._v("メールアドレス宛にパスワード再設定用の認証コードを送付したします。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_vm._v("メールアドレスに認証コードを送信しました。"), _c('br'), _vm._v("認証コードの有効期限は発行から10分間です。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-172e8317"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/Login.vue
// module id = 883
// module chunks = 1